export default {
    list:[
        {
            name: 'Туры',
            src: '/tourclient/spa/#/search/',
            icon: 'mag-icon-nav-menu-search-tours',
            old: true,
            min: true,
        },
        {
            name: 'Авиабилеты',
            src: '/tourclient/flightsearch/flights.html',
            icon: 'mag-icon-nav-menu-search-flights',
            old: true,
            min: true,
        },
        {
            name: 'Отели',
            src: '/tourclient/hotelsearch/hotels.html',
            icon: 'mag-icon-nav-menu-search-hotels',
            old: true,
            min: true,
        },
        {
            name: 'Конструктор туров',
            src: '/app/#/admin/tour',
            icon: 'mag-icon-nav-menu-search-tours',
            old: true,
            min: true,
        },
        {
            name: 'Продажа туров',
            src: '/app/#/tour',
            icon: 'mag-icon-nav-menu-search-tours',
            old: true,
            min: true,
        },
        {
            name: 'Проведение туров',
            src: '/app/#/admin/statistic',
            icon: 'mag-icon-nav-menu-search-tours',
            old: true,
            min: true,
        },
        {
            name: 'Страховки',
            src: '/tourclient/insurances',
            icon: 'mag-icon-nav-menu-search-insurance',
            old: true,
            min: true,
        },
        {
            name: 'Путевки',
            src: '/tourclient/spa/#/orders',
            icon: 'mag-icon-nav-menu-orders',
            old: true,
            min: false,
        },
        {
            name: 'Туристы',
            src: '/tourclient/admin/clients/list.html',
            icon: 'mag-icon-nav-menu-clients',
            old: true,
            min: false,
        },
        {
            name: 'Лиды',
            src: '/tourclient/spa/#/leads/list/',
            icon: 'mag-icon-nav-menu-leads',
            old: true,
            min: false,
        },
        {
            name: 'Финансы',
            src: '/finances',
            icon: 'mag-icon-nav-menu-payments',
            old: false,
            min: false,
        },
        {
            name: 'Статистика',
            src: '/tourclient/admin/statistic/index.html',
            icon: 'mag-icon-nav-menu-statistic',
            old: true,
            min: false,
        },
        {
            name: 'Задачи',
            src: '/tourclient/admin/tasks/list.html',
            icon: 'mag-icon-nav-menu-tasks',
            old: true,
            min: false,
        },
        {
            name: 'События',
            src: '/tourclient/admin/events/index.html',
            icon: 'mag-icon-nav-menu-events',
            old: true,
            min: false,
        },
        {
            name: 'Партнеры',
            src: '/tourclient/admin/partners/list.html',
            icon: 'mag-icon-nav-menu-partners',
            old: true,
            min: false,
        },
        {
            name: 'Справочники',
            src: '/tourclient/admin/dicts/index.html',
            icon: 'mag-icon-nav-menu-directories',
            old: true,
            min: false,
        },
        {
            name: 'Личный кабинет',
            src: '/lk',
            icon: 'mag-icon-nav-menu-lk',
            old: false,
            min: false,
        },
        {
            name: 'Сертификаты',
            src: '/tourclient/index.html#/finances/certificates/search',
            icon: 'mag-icon-nav-menu-lk',
            old: false,
            min: false,
        },
    ]
}
